import React, {
  useContext,
} from 'react';
import classNames from 'classnames';

import { useWindowStore } from '../../../stores';
import SiteSeeContext from '../../SiteSeeGuides/SiteSeeContext';
import { getPulseTarget, PULSE_TARGETS } from '../../SiteSeeGuides/SiteSeeGuideData';
import useSiteSeeModalDims from '../../SiteSeeGuides/useSiteSeeModalDims';

import MapControlsZoomMore from './MapControlsZoom/MapControlsZoomMore';
import MapControlsZoomLess from './MapControlsZoom/MapControlsZoomLess';
import MapControlsZoomReset from './MapControlsZoom/MapControlsZoomReset';
import MapControlsMapTypeToggle from './MapControlsMapTypeToggle/MapControlsMapTypeToggle';
import MapControlsPOIToggle from './MapControlsPOIToggle/MapControlsPOIToggle';
import MapControlsMarkersToggle from './MapControlsMarkersToggle/MapControlsMarkersToggle';
import SiteSeeTipTrigger from '../../SiteSeeTipTrigger/SiteSeeTipTrigger';
import VectreInfo from '../../VectreInfo/VectreInfo';

import './MapControls.scss';

const MapControls = () => {
  const {
    siteSeeGuideId,
    siteSeeGuideMode,
  } = useContext(SiteSeeContext);

  const isMobile = useWindowStore((state) => state.isMobile);

  // Determine if controls should pulse based on active guide
  const isCoached = siteSeeGuideMode === 'tour';
  const pulseTarget = getPulseTarget(siteSeeGuideId, isMobile);
  const isPulsing = isCoached && pulseTarget === PULSE_TARGETS.CONTROLS;

  // Pass dims back to sitesee guide.
  // Hook returns a callback ref that triggers measurement when element mounts
  const mapControlsRef = useSiteSeeModalDims({ id: 'controls' });

  return (
    <div className="mapControls__wrapper">

      <div className="mapControls__innerWrapper">
        <SiteSeeTipTrigger siteSeeTipId="controls" />

        <div
          className={classNames('mapControls', {
            'mapControls--pulsing': isPulsing,
          })}
          ref={mapControlsRef}
        >
          <MapControlsZoomMore />
          <MapControlsZoomLess />
          <MapControlsZoomReset />
          <MapControlsMapTypeToggle />
          <MapControlsPOIToggle />
          <MapControlsMarkersToggle />
        </div>

        <VectreInfo />

      </div>
    </div>
  );
};

export default MapControls;
